/*
* @Description: 接口列表
* @Author: FengQi
* @Email: zhaolong.dzl@alibaba-inc.com
* @Date:   2018-11-07 16:15:34
* @Last Modified by:   FengQi
* @Last Modified time: 2019-01-03 00:20:09
* @Copyright(c) 2018 Taobao.com
*/
export default {
  daily: 'daily.taobao.net',
  prod: 'taobao.com',
  path: {
    login: '/ocs/H5Customer/H5Login.do',
    resume: '/ocs/ResumeSession.do',
    isWorking: '/ocs/H5Customer/QueryWorkingHours.do',
    dispatch: '/ocs/H5Customer/H5Dispatch.do',
    ping: '/ocs/KeepAlive.do',
    polling: '/webim/messages',
    ack: '/webim/message/ack',
    send: '/ocs/H5Customer/H5CustomerSendMsg.do',
    historyMessageByPage: '/im/GetMessageLogByPage.do',
    getSessionMessage: '/ocs/H5Customer/GetSessionChatHistory.do',
    getQueueInfo: '/ocs/H5Customer/H5QueueInfo.do',
    getOSSInfo: '/ocs/H5Customer/OssConfig.do',
    getRate: '/ocs/H5Customer/RatingConfig.do',
    submitRate: '/ocs/H5Customer/SubmitRate.do',
    sendOffline: '/webim/offline/message/send',
    getQueueNumber: '/ocs/GetSkillGroupQueueWaitingNumber.do',
    checkOcsSource: '/ocs/CheckOcsSource.do',
    getOcsQueueNotice: '/ocs/GetOcsQueueNotice.do',
    getSourceIdConfigDetail: '/ocs/GetSourceConfigById.do',
    memberLeave: '/ocs/MemberLeave.do',
    historyMessage: '/im/GetMessageLog.do',
    createEvaluation: '/support/onlinecs/sdk/ocs/createEvaluation.do',
    submitEvaluation: '/support/onlinecs/sdk/ocs/submitEvaluation.do',
    reportHttpRequestIssue: '/report/reportHttpRequestIssue.do',

    // for OSP（客服端）
    words: '/support/onlinecs/AjaxWordsLanguages.do',
    sendFileMessage: '/support/onlinecs/SendFileMessageJson.do',
    sendTextMessage: '/support/onlinecs/send_text_message.do',
    servicerLeave: '/support/onlinecs/ServicerLeave.do',
    servicerChangeStatus: '/support/onlinecs/servicerChangeStatus.do',
    workInfo: '/support/onlinecs/ServicerWorksetInfo.do',
    specialWorkInfo: '/support/onlinecs/SpecialityStatus.do',
    submitSpecialty: '/support/onlinecs/SubmitUseSpeciality.do',
    switchQueue: '/support/onlinecs/switchQueue.do',
    servicerKeepAlive: '/support/onlinecs/keep_alive.do',
    onlineAjaxWorkStatus: '/support/onlinecs/OnlineAjaxWorkStatus.do',
    messageLog: '/support/onlinecs/getMessageLogBySid.do',
    messageLogAlicare: '/im/GetMessageLogForServicer.do',
    getOcsSessionUserByServicerId: '/support/onlinecs/getOcsSessionUsersByServicerId.do',
    searchOcsSessionUsersByInfo: '/support/onlinecs/searchOcsSessionUsersByInfo.do',
    anywatcherCheckMessage: '/anywatcher/AnyWatcherCheckAndGetDetail.do',
    anywatcherSaveMessage: '/anywatcher/AnyWatcherSaveMessage.do',
    urlSafetyCheck: '/im/MsgSecurityCheck.do',
    recordViewFullName: '/ocs/SaveOperatorLogBySid.do',
    tokenCode: '/auth/GetTokenCode.do',
    p2pAcceptJoin: '/p2p/AcceptP2PDispatch.do',
    p2pDenyJoin: '/p2p/RejectP2PDispatch.do',
    ocsSystemMessage: '/support/onlinecs/sdk/CsSendSystemMessage.do',
    syncUsers: '/support/onlinecs/AjaxGetUserJoinInfo.do',
    revertMessage: '/im/RevertMessage.do',
    deleteMessage: '/im/DeleteMessageLog.do',

    // for OCS（会员端）
    clearQueue: '/support/onlinecs/sdk/CsClearQueue.do',
    checkUserName: '/support/minerva/sdk/minerva_login.do',
    feedback: '/support/onlinecs/sdk/CsFeedback.do',
    uploadFile: '/support/onlinecs/sdk/cs_post_file_message.do',
    getAnnouncement: '/support/onlinecs/sdk/ocsReceiveNotice.do',
    queueInfo: '/support/onlinecs/sdk/csQueueInfo.do',
    sendWWMessage: '/support/onlinecs/sdk/csSendWWMessage.do',
    getSourceConfig: '/support/sdk/sourceIdConfigDetail.do',
    getServiceStatus: '/support/onlinecs/sdk/cs_service_status.do',
    getHotKnowledge: '/support/onlinecs/ocs/hotKnowledge.do'
  }
};


// WEBPACK FOOTER //
// ./node_modules/_@ali_im-sdk-third@0.1.8@@ali/im-sdk-third/lib/const.js